import { ptzaConfig } from '../../controllers/config.js';

class ModulesManager {
    modules = {      
        addons: {
            export: 'ptzaAddons',
            loader: () => import('../../controllers/modules/addons/index.js'),
        },
        cart: {
            export: 'ptzaCarrito',
            loader: () => import('./cart/index.js'),
        },
        faq: {
            export: 'ptzaFaq',
            loader: () => import('./faq/index.js'),
        },
        news: {
            export: 'ptzaNews',
            loader: () => import('./news/index.js'),
        },
        contact: {
            export: 'ptzaContact',
            loader: () => import('./contact/index.js'),
        },
        panel: {
            export: 'ptzaPanel',
            loader: () => import('./panel/index.js'),
        },
    };

    async init() {
        const configPage = ptzaConfig.getPageConfig();
        if (!configPage || typeof configPage !== 'object') return false;

        window.PTZA.modules = window.PTZA.modules || {};

        for (const [key, moduleConfig] of Object.entries(configPage)) {
            if (!moduleConfig || moduleConfig.enabled !== true) continue;

            const moduleMeta = this.modules[key];
            if (!moduleMeta) continue;

            try {
                const mod = await moduleMeta.loader();
                const instance = mod[moduleMeta.export];

                if (!instance) {
                    console.warn(`No se encontró el export ${moduleMeta.export} para el módulo ${key}`);
                    continue;
                }

                window.PTZA.modules[key] = instance;

                if (typeof instance.init === 'function') {
                    await instance.init();
                }
            } catch (e) {
                console.error(`Error cargando módulo ${key}:`, e);
            }
        }

        return true;
    }
}

export const ptzaModulesManager = new ModulesManager();